// extracted by mini-css-extract-plugin
module.exports = {"toggler":"ProductsDesktop_toggler__D3aBI","navList":"ProductsDesktop_navList__M_eUG"};